module.exports = require("date-fns/get_year");


//////////////////
// WEBPACK FOOTER
// external "date-fns/get_year"
// module id = 40
// module chunks = 0